// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SettingsDescription-module__description--inqFF{margin:5px 0 15px 0;font-size:13px;color:#7b7f83}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"description": `SettingsDescription-module__description--inqFF`
};
export default ___CSS_LOADER_EXPORT___;
